// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { PlacementFrontend } from '@post-office/browser--migrations-shared-experiences/fastshift-portal';

import { type MessageTemplateContext } from '../../../index';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: (props: MessageTemplateContext) => {
			return (
				<div>
					<div>testProp: {props.testProp}</div>
					<div>testObjProp.testObjPropKey: {props.testObjProp.testObjPropKey}</div>
					<div>testArrayProp: {props.testArrayProp.join(', ')}</div>
				</div>
			);
		},
	},
});
